import './App.css';
import { RouterProvider } from 'react-router-dom';
import { MinimizeContextProvider } from './context/LayoutContext';
import { router } from './routes/RoutesConfig';
import 'react-toastify/dist/ReactToastify.css';
import './styles/CustomToast.css';
import MetaPixel from './components/common/pixels/MetaPixel';
import ClarityInit from './components/common/pixels/ClarityInit';
import { LanguageProvider } from './context/LanguageContext';
import './i18n';
import 'react-range-slider-input/dist/style.css';
import { Suspense } from 'react';
function App() {
  return (
    <div className="w-full max-w-full m-auto">
      <MetaPixel />
      <ClarityInit />
      <Suspense>
        <LanguageProvider>
          <MinimizeContextProvider>
            <RouterProvider router={router} />
          </MinimizeContextProvider>
        </LanguageProvider>
      </Suspense>
    </div>
  );
}

export default App;
